import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/mentions-legales")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:type", content: "website" },
      { title: "Mentions légales — Mathys Gautier" },
      {
        name: "description",
        content:
          "Informations légales du site de Mathys Gautier : éditeur, directeur de la publication, hébergement Cloudflare, propriété intellectuelle et données personnelles.",
      },
      { property: "og:title", content: "Mentions légales — Mathys Gautier" },
      {
        property: "og:description",
        content:
          "Informations légales du site de Mathys Gautier : éditeur, directeur de la publication, hébergement Cloudflare, propriété intellectuelle et données personnelles.",
      },
      { name: "robots", content: "index, follow" },
    ],
  }),
  component: MentionsLegales,
});

function MentionsLegales() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <p className="eyebrow">Informations légales</p>
      <h1 className="mt-12 font-serif text-5xl">Mentions légales</h1>
      <p className="mb-20 max-w-2xl text-sm leading-relaxed text-muted-foreground">
        Informations relatives à l’éditeur, à l’hébergement et aux conditions d’utilisation de ce
        site personnel, conformément à la loi pour la confiance dans l’économie numérique (LCEN).
      </p>

      <div className="space-y-10 text-sm leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl">Éditeur du site</h2>
          <p className="mt-3 text-muted-foreground">
            Mathys Gautier — site personnel à vocation professionnelle (portfolio journalistique),
            édité à titre non commercial. Contact :{" "}
            <a href="mailto:mathys.gautier@sciencespo.fr">mathys.gautier@sciencespo.fr</a>.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Directeur de la publication</h2>
          <p className="mt-3 text-muted-foreground">Mathys Gautier.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Hébergement</h2>
          <p className="mt-3 text-muted-foreground">
            Le site est hébergé et distribué par <strong>Cloudflare, Inc.</strong>, 101 Townsend
            Street, San Francisco, CA 94107, États-Unis (
            <a href="https://www.cloudflare.com" target="_blank" rel="noreferrer noopener">
              cloudflare.com
            </a>
            ). Les contenus sont servis depuis le réseau mondial de Cloudflare : certaines requêtes
            techniques peuvent donc transiter hors de l’Union européenne. Ces transferts sont
            encadrés par les clauses contractuelles types de la Commission européenne et par le
            Data Privacy Framework. La base de données et les fichiers médias sont hébergés dans
            l’Union européenne.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Propriété intellectuelle</h2>
          <p className="mt-3 text-muted-foreground">
            Les textes, visuels et productions présentés sont la propriété de leurs auteurs
            respectifs ou des médias les ayant publiés. Toute reproduction, même partielle, est
            soumise à autorisation préalable. Les liens vers les articles renvoient vers les sites
            des éditeurs d’origine.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl">Données personnelles</h2>
          <p className="mt-3 text-muted-foreground">
            Le détail des données traitées, de leur durée de conservation et de vos droits est
            présenté dans la{" "}
            <Link to="/confidentialite">politique de confidentialité</Link>.
          </p>
        </section>
      </div>
    </div>
  );
}
